import { useState, useRef, useCallback } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { motion } from "framer-motion";
import { NavLink } from "react-router-dom";
import { useTranslation } from "../../hooks/useTranslation";
import TrainerModal from "../../components/trainers/TrainerModal";

export default function TrainersShort({
    data,
    title,
    ctaPath = "/edzok",
    ctaLabel,
    motionOrder = 0,
}) {
    const t = useTranslation();
    const [active, setActive] = useState(null);
    const cardsRef = useRef({});

    /* ------------ DATA (unchanged) --------------------------------- */
    const trainers = [
        {
            id: 1,
            key: "roland",
            img: require("../../assets/images/trainers/roland.jpg"),
            phone: "+36 30 491 9340",
            insta: "https://instagram.com/fit_by_roy",
            mail: "mailto:apika89305@gmail.com",
        },
        {
            id: 2,
            key: "daniella",
            img: require("../../assets/images/trainers/daniella.jpg"),
            phone: "+36 30 959 2613",
            insta: "https://instagram.com/daniella_bakos",
            mail: "mailto:daniellabakos6@gmail.com",
        },
        {
            id: 3,
            key: "eszter",
            img: require("../../assets/images/trainers/eszter.jpg"),
            phone: "+36 70 380 9749",
            insta: "",
            mail: "mailto:f.patakieszter@gmail.com",
        },
    ];

    /* ------------ i18n helpers ------------------------------------- */
    const name = (slug) => t(`trainers.list.${slug}.name`);
    const bio = (slug) => t(`trainers.list.${slug}.bio`);
    const label = (k) => t(`trainers.labels.${k}`);

    /* ------------ restore focus after close ------------------------ */
    const handleClose = useCallback(() => {
        setActive(null);
        setTimeout(() => {
            cardsRef.current[active?.id]?.focus?.({ preventScroll: true });
        }, 0);
    }, [active]);

    // animation helper
    const fadeUp = i => ({
        hidden: { opacity: 0, y: 40 },
        show: {
            opacity: 1,
            y: 0,
            transition: { delay: (motionOrder + i) * 0.05, duration: 0.4 },
        },
    });

    // UI text fallbacks
    const headline = t("home.trainers.title");
    const buttonLabel = t("home.trainers.viewFull");

    return (
        <section id="trainersShort">{/* reuse dark wrapper for bg */}
            <motion.div
                className="text-center"
                variants={fadeUp(0)}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true, margin: "-50px" }}
            >
                <Container className="trainersShortContainer">
                    {/* Headline + CTA */}

                    <h3 className="trainersShortTitle mb-5 mt-4">{headline}</h3>

                    <Row className="trainersShortRow">
                        {trainers.map((tr, idx) => (
                            <Col
                                key={tr.id}              // or tr.key  — anything unique & stable
                                xl={4}
                                md={6}
                                sm={12}
                                className="d-flex"
                            >
                                <motion.div
                                    className="glassPaneShort w-100 p-0 d-flex flex-column"
                                    variants={fadeUp(idx + 1)}
                                    initial="hidden"
                                    whileInView="show"
                                    viewport={{ once: true, margin: "-50px" }}
                                    whileHover={{ scale: 1.04 }}
                                    transition={{ duration: 0.35, ease: "easeInOut" }}
                                >
                                    <Card
                                        className="trainer-card glass-trainer"
                                        onClick={() => setActive(tr)}
                                        tabIndex={0}
                                        onKeyUp={(e) => e.key === "Enter" && setActive(tr)}
                                        ref={(el) => (cardsRef.current[tr.id] = el)}
                                    >
                                        <div className="trainer-box">
                                            <Card.Img
                                                src={tr.img}
                                                alt={name(tr.key)}
                                                className="trainer-photo"
                                                loading="lazy"
                                            />
                                        </div>
                                    </Card>
                                </motion.div>
                            </Col>
                        ))}
                    </Row>
                    <div className="text-center mt-5" >
                        <NavLink to={ctaPath} className="trainersShortBtn btn btn-outline-warning p-3">
                            {buttonLabel}
                        </NavLink>
                    </div>
                </Container>
            </motion.div>




            {/* Light‑box overlay ---------------------------------------- */}
            <TrainerModal
                trainer={active}
                labels={label}
                name={name}
                bio={bio}
                onClose={handleClose}
            />
        </section>
    );
}
